import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlexComponent } from './simple-icons-plex.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlexComponent ],
    exports:      [ SimpleIconsPlexComponent ],
    bootstrap:    []
})
export class SimpleIconsPlexModule {}
